import { render, staticRenderFns } from "./KYCSignInSecondFactor.vue?vue&type=template&id=764e7c74&scoped=true"
import script from "./KYCSignInSecondFactor.vue?vue&type=script&lang=ts"
export * from "./KYCSignInSecondFactor.vue?vue&type=script&lang=ts"
import style0 from "./KYCSignInSecondFactor.vue?vue&type=style&index=0&id=764e7c74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764e7c74",
  null
  
)

export default component.exports